/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import * as R from 'ramda';

const iconStyles = { position: 'absolute', right: 12, top: 14 };

const renderInput = R.curry(({ label, length, loading, optional = false }, inputParams) => (
  <TextField
    helperText={optional ? 'Optional' : null}
    {...inputParams}
    label={label}
    slotProps={{
      htmlInput: { ...inputParams.inputProps },

      input: {
        ...inputParams.InputProps,
        endAdornment: loading ? (
          <CircularProgress size={20} sx={{ color: 'secondary.main', ...iconStyles }} />
        ) : !length ? (
          <Tooltip title="No options available">
            <InfoRoundedIcon sx={{ color: 'graphic.main', ...iconStyles }} />
          </Tooltip>
        ) : (
          inputParams.InputProps.endAdornment
        ),
      },
    }}
  />
));

export default renderInput;
